(() => {
  'use strict';

  const icons = document.querySelectorAll('[data-tab-favicon]');
  if (!icons.length) return;

  const update = () => {
    const attribute = document.hidden ? 'data-favicon-inactive' : 'data-favicon-active';
    icons.forEach((icon) => {
      const href = icon.getAttribute(attribute);
      if (href && icon.getAttribute('href') !== href) icon.setAttribute('href', href);
    });
  };

  update();
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
})();
